exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{height:100%}#app.mirror:after,#app.mirror:before{content:\"MIRROR\";display:block;width:100%;text-align:center;background:#e53838;color:#fff;font-size:14px;z-index:9999}#app.mirror:after{position:absolute;top:0}#app .dropdown-toggle-no-caret:after{display:none}", ""]);

// exports
